import $ from "jquery";
import eventManager from "../../store/sqftEventManager";
import Config from "../../store/sqftConfig";
import workspace from "../workspace";
import Cursor from "./cursor";
import MiteredOverlay from "../shapes/overlays/mitered";
import {
  inchesToMm,
  measureDistanceToInches,
  mmToInches,
} from "../../../../helpers/sqftHelper";
import {iconPlusBlue} from "../../../../assetsSQFT";
import store from "../../../../../../store";
import {
  addMiteredSection,
  changeMiteredSection,
  deleteMiteredSection
} from "../../../../../../actions/sqftMiteredFunctions";
import {updateSQFTCalculations} from "../../../../../../actions/sqftFunctions";
import {
  EDGE_LABELS,
  MITERED_OVERLAY_TYPE,
  RESOURCE_ATTACHED_TO_TYPE,
  SIDEBAR_BUTTONS_MENU, SIDEBAR_HIDDEN_BUTTONS,
  SIDEBAR_NAVIGATION_BUTTONS
} from "../../../../constants";
import {setSQFTMenuOpened, setSQFTMenuOpenedLock} from "../../../../../../actions/sqftMenuFunctions";
import {attachResource} from "./resourseCanas";
import {getEdgeFeatures} from "../../../../helpers/shapeHelper";
import {getMiterEdgeFeature, getMiterUnderwrap} from "../../../../helpers/featureHelper";

export default class MiteredController {
  cursor;
  design = {
    imgSrc: iconPlusBlue
  };
  nodes = {
    miteredSectionsHTML: $('#mitered-sections'),
  };
  miteredSections = [];
  miterEdgeFeature = null;
  hasPreparedMiterEdgeFeature = false;
  miterUnderwrapFeature = null;

  prepareMiterEdgeFeature = () => {
    if (!this.hasPreparedMiterEdgeFeature) {
      this.miterEdgeFeature = getMiterEdgeFeature();
      // Retry later if edge features were not loaded when the tool was opened.
      this.hasPreparedMiterEdgeFeature = !!this.miterEdgeFeature;
    }

    return this.miterEdgeFeature;
  };

  createCursor = () => {
    this.cursor = new Cursor();
    this.cursor.setCursorImage(this.design.imgSrc);
    eventManager.setCursor('mitered-select', this, true);
  };

  registerEvents = () => {
    eventManager.addEvent(
      eventManager.events.MOUSE_UP,
      this.onMouseUp,
      this,
      eventManager.priorities.OVERALL
    );
  };

  attachMiteredEdge = (seg) => {
    if (seg && !seg.isWithMitered() && !seg.isWithBumpout()) {
      const miterEdgeFeature = this.prepareMiterEdgeFeature();

      //add tool
      attachResource(seg, null, RESOURCE_ATTACHED_TO_TYPE.mitered, null, null, '', 0, null, null, false);

      //add green edge
      if (miterEdgeFeature) {
        const name = miterEdgeFeature.getFeatureName();
        attachResource(
          seg,
          null,
          RESOURCE_ATTACHED_TO_TYPE.edge,
          miterEdgeFeature.dbFeature.id,
          miterEdgeFeature.partId,
          name
        );
      }
    }
  };

  attachMiteredUnderwrapEdge = (seg, selectedMiterUnderwrapFeature = null) => {
    if (seg && !seg.isWithMitered() && !seg.isWithBumpout()) {
      this.miterUnderwrapFeature = selectedMiterUnderwrapFeature
        || this.miterUnderwrapFeature
        || getMiterUnderwrap();
      const miterEdgeFeature = this.miterUnderwrapFeature;

      //add tool
      attachResource(seg, null, RESOURCE_ATTACHED_TO_TYPE.mitered, null, null, '', 0, null, null, false);

      //add green edge
      if (miterEdgeFeature) {
        const name = miterEdgeFeature.getFeatureName();
        attachResource(
          seg,
          null,
          RESOURCE_ATTACHED_TO_TYPE.edge,
          miterEdgeFeature.dbFeature.id,
          miterEdgeFeature.partId,
          name
        );
      }
    }
  };

  onMouseUp = (mousePos) => {
    void mousePos;
    let hoverShape = workspace.getHoverShape();

    if (hoverShape && hoverShape.getHoverSegment) {
      const reduxState = store.getState();
      const activeButton = reduxState.sqftMenuState.activeButton;
      const activeSubMenuButton = reduxState.sqftMenuState.activeSubMenuButton;
      if (activeButton === SIDEBAR_NAVIGATION_BUTTONS.mitered || activeSubMenuButton === SIDEBAR_HIDDEN_BUTTONS.buttonMitered) {
        let seg = hoverShape.getHoverSegment();
        if (seg && seg.isWithMitered() && reduxState.sqftMenuState.activeButton === SIDEBAR_BUTTONS_MENU.delete) {
          seg.deleteMitered();
        } else if (seg && seg.isWithMitered()) {
          void 0;
        } else {
          this.attachMiteredEdge(seg, this.cursor.cursorImage);
        }
      }
    }

    this.cursor.checkForRestoreCursor();
  };

  addSection = (miteredSection) => {
    const reduxState = store.getState();
    store.dispatch(addMiteredSection(miteredSection));
    store.dispatch(setSQFTMenuOpened(SIDEBAR_NAVIGATION_BUTTONS.mitered));
    const updateCalculations = reduxState.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  };

  updateSection = (miteredSection) => {
    store.dispatch(changeMiteredSection(miteredSection));
    store.dispatch(setSQFTMenuOpened(SIDEBAR_NAVIGATION_BUTTONS.mitered));
    store.dispatch(setSQFTMenuOpenedLock(true));

    const reduxState = store.getState();
    const updateCalculations = reduxState.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  }

  deleteSection = (miteredOverlay) => {
    store.dispatch(deleteMiteredSection(miteredOverlay.id));
  };

  createMiteredOverlay = (line) => {
    const reduxState = store.getState();
    const miteredSections = reduxState.sqftMiteredState.miteredSections;

    return new MiteredOverlay(line, miteredSections.length + 1, MITERED_OVERLAY_TYPE.mitered)
  };

  destroy = (protect, revertBackAfterMouseUp) => {
    if (revertBackAfterMouseUp) {
      eventManager.removeEvent(self, eventManager.events.RENDER); //remove render only, but wait for mouse up to set cursor again
      this.isWaitingToRestoreCursor = true;
    } else {
      this.deregisterEvents();
    }
    //this.hide();
  };

  deregisterEvents() {
    eventManager.resetCursor(this);
    eventManager.removeEvent(this);
    this.cursor ? this.cursor.deregisterEvents() : null;
    Config.highlight.lines = false;
  }

  static getTotalArea = () => {
    let miteredSections = workspace.getMiteredSections();
    let miteredSectionsArea = 0;
    for (let i = 0; i < miteredSections.length; i++) {
      miteredSectionsArea += miteredSections[i] ? miteredSections[i].getMiteredToolTotalArea() : null;
    }

    return miteredSectionsArea;
  };

  onMeasureUnitChange = () => {
    let miteredSections = workspace.getMiteredSections();
    let miteredSectionsArea = 0;
    for (let i = 0; i < miteredSections.length; i++) {
      let segments = miteredSections[i].getSegments();

      segments.map((segment) => {
        segment.height = Config.measureUnit === "Metric"
          ? inchesToMm(segment.height)
          : mmToInches(segment.height);

        if (segment.thickness) {
          segment.thickness.value = Config.measureUnit === "Metric"
            ? inchesToMm(segment.thickness.value)
            : mmToInches(segment.thickness.value)
        }
      });

      miteredSections[i].heightNumberText.value = segments[0].height
    }

    return miteredSectionsArea;
  };

  getTransformedMeasureUnit = (value) => {
    return Config.measureUnit === "Metric"
      ? measureDistanceToInches(value).millimeters // ? distanceToMillimeters(inchesToMm(segment.length.value))
      : value;
  };

  getEdgesLength = () => {
    let additionalLength = 0;
    const lines = workspace.getLines();
    for (const line of lines) {
      if (line.from.getMiteredFeatureId()) {
        additionalLength += this.getEdgeLengthValue();
      }
    }

    return additionalLength
  }

  getEdgeLengthValue = () => {
    return Config.measureUnit === "Imperial"
      ?  (2 * 33) / 40
      : (2 * 900) / 1000;
  }

  getExportedMiteredEdges = () => {
    let addedEdges = [];
    const lines = workspace.getLines();
    for (const line of lines) {
      const miteredFeatureId = line.from.getMiteredFeatureId();
      if (miteredFeatureId) {
        const edgeLengthValue = this.getEdgeLengthValue();
        const navItems = getEdgeFeatures();
        let edgeFeature = navItems.find(edge => edge.part.dbFeature.id === miteredFeatureId);

        addedEdges.push({
          partId: EDGE_LABELS.edge,
          type: EDGE_LABELS.edge,
          name: edgeFeature ? workspace.intl.formatMessage({id: edgeFeature.part.dbFeature.sharedFeatureName}) : "",
          featureId: miteredFeatureId,
          segments: 1,
          length: edgeLengthValue,
          area: edgeLengthValue
        });
      }
    }

    return addedEdges
  }
}
